import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import FiberSetReferencePowerTable from '../fibersetreferencepowertable'
import FiberSetReferenceLengthTable from '../fibersetreferencelengthtable'

class FiberSetReferenceView extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit
    } = this.props

    const setreference = results.data.setreference;

    return (
      <div ref="container">
        <Paper className={classes.paper}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h1>{translate('fiber_setreference_heading')}</h1>
                <Grid container spacing={0}>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='flex-start'>
                        <h4 className={classes.fiberInfo}><strong>{translate('fiber_setreference_configuration')}</strong> : {setreference.configuration}</h4>
                    </Grid>
                    {(results.data.trcverify !== 1 && setreference.verification.length !== 0) ?
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='flex-end'>
                        <h4 className={classes.fiberInfo}><strong>{translate('fiber_setreference_verification')}</strong> : {setreference.verification}</h4>
                    </Grid> : null}                   
                </Grid>
                {setreference.displayRefPower !== 0 ?                 
                <h2>{translate('fiber_setreference_refpower_heading')}</h2> : null}
                {setreference.displayRefPower !== 0 ?                 
                <FiberSetReferencePowerTable
                    setreference={setreference}
                    translate={translate}
                /> : null}
            </Grid>
        </Paper>
      </div>
    )
  }
}

export default withStyles(styles)(FiberSetReferenceView)
